// libs
import React, { memo } from 'react';

// styles
import { Container, InnerLoader, BubbleContainer, Bubble, SpinningBubbles } from './styles';
import { useDomainConfig } from 'shared/domainConfig/context/context';

// defs
interface ILoaderProps {
  fixed?: boolean;
  className?: string;
  loaderClassName?: string;
}

const DOT_COUNT = 8;

const Loader = ({ fixed = false, className = '', loaderClassName = '' }: ILoaderProps) => {
  const { COLOR: { LOADER } } = useDomainConfig();
  const dots = (key: number) => (
    <BubbleContainer data-test="dots" key={key}>
      <Bubble color={LOADER} />
    </BubbleContainer>
  );

  const dotsList = new Array(DOT_COUNT).fill(dots);

  return (
    <Container className={className} fixed={fixed} data-test="loader-cnt">
      <InnerLoader className={loaderClassName}>
        <SpinningBubbles>{dotsList.map((dot, i) => dot(i))}</SpinningBubbles>
      </InnerLoader>
    </Container>
  );
};

export default memo(Loader);
